import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import DateHelperClass from '@/helpers/DateHelper' 

    export class TodoModel extends Model  {
      key: string;
      user_key:string;
      customer_key: string;
      dossier_key: string;
      task_key: string;
      priority: number = 0;
      name:string = "";
      description: string = "";
      _start_at: number = DateHelperClass.getCurrent("ms") as number;
      timeindication: string;
      workhours:number;
      type:number = 1;
      state:number = 5;
      
        constructor(data = null) {
            super();
            
            if(data) {
                this.createModel(data);
            }
            
        }
     
        get start_at() {
            if(!this._start_at) {
                let tmpVal: number = DateHelperClass.getCurrent("ms") as number;
                this._start_at = tmpVal;
            }
            return this._start_at;
        }   
        set start_at(val) {
            this._start_at = val;
        }
        
        getStartAt(format) {
            let startAt = this._start_at;
            DateHelperClass.getCurrent("DDMMYYYY");
            return DateHelperClass.getCurrent("ms");
        }
    }